import React, { Component } from 'react';

export default class Header extends Component {

    render() {

        return (
	   
            <header>
		
                <div className="container-fluid">
                    <div className="row">
                        <div className="col align-self-center">
                            <div className="logo">
                            <a href="https://www.smallhd.com" target="_blank"> <img src="https://activate.smallhd.com/images/logo.png" alt="logo" /> </a>
                            </div>
                        </div>

                        <div className="col align-self-center text-center">
                            <h1 className="m-0">Activation</h1>
                        </div>

                        <div className="col align-self-center text-right">
                            <div className="user">
                                <a href="https://www.smallhd.com" target="_blank"><i className="fa fa-user-circle-o fa-2x" aria-hidden="true"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );

    }

}
